import { Component } from 'react';
import * as React from 'react';
import Raven from 'raven-js';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
class ErrorBoundary extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      caughtError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      caughtError: true
    };
  }
  componentDidCatch(error, info) {
    console.error(error);
    Raven.captureException(error, {
      extra: {
        info,
        boundaryName: this.props.boundaryName
      }
    });
  }
  render() {
    const {
      children,
      renderError
    } = this.props;
    const {
      caughtError
    } = this.state;
    if (caughtError) {
      return renderError();
    }
    return children;
  }
}
ErrorBoundary.defaultProps = {
  renderError: () => /*#__PURE__*/_jsx(UIErrorMessage, {
    type: "badRequest",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-ui.global.errorBoundary.title"
    }),
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "flow-doctor-ui.global.errorBoundary.description_jsx",
      elements: {
        Link: UILink
      },
      options: {
        refreshProps: {
          onClick: () => window.location.reload()
        },
        teamNameProps: {
          teamName: 'Automation Triggers FE',
          external: true,
          href: 'https://hubspot.slack.com/archives/C01MWLFE12Q'
        }
      }
    })
  })
};
export default ErrorBoundary;